import React from 'react'
import {Button, Icon} from "@blueprintjs/core"


export default function ({orderSnapshot}) {
  function removeOrder () {
    orderSnapshot.ref.remove()
  }
  function changeDueTS () {
    orderSnapshot.ref.update({
      deliveryTime: Number(orderSnapshot.child('deliveryTime').val()) - 24 * 60 * 60 * 1000
    })
  }
  // if (!process.env.REACT_APP_ADMIN) {
  //   return null
  // }
  return(
    <div>
      {/* <Button onClick={removeOrder}>Delete</Button> */}
      {/* <Button onClick={changeDueTS}>DueTS minus 1 day</Button> */}

    </div>
  )
}
